import { render, staticRenderFns } from "./tl-login.vue?vue&type=template&id=6cf4b031"
import script from "./tl-login.vue?vue&type=script&lang=js"
export * from "./tl-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports